
import api from './api';

class Zone {

	constructor (Api) {
		this.Api = Api;
	}

	all () {
		return this.Api.get({
			url:  'v1.1/m/zones'
		}).then(response => response.zones);
	}

	create (name, description) {
		return this.Api.post({
			url:  'v1.1/m/zones',
			body: {
				name,
				description,
				timezone: '+00:00'
			}
		}).then(response => response.zone);
	}

	update (zoneId, name, description) {
		return this.Api.put({
			url:  'v1.1/m/zones/'+zoneId,
			body: {
				name,
				description,
				timezone: '+00:00'
			}
		}).then(response => response.zones);
	}

	delete (zoneId) {
		return this.Api.delete({
			url:  'v1.1/m/zones/'+zoneId
		}).then(response => response.zones);
	}

}

Zone.$inject = ['Api'];

export default angular.module('service.zone', [api])
	.service('Zone', Zone)
	.name;



// WEBPACK FOOTER //
// ./src/service/zone.js